import React from 'react';
import { useTheme } from 'styled-components';
import {
  DialogComponent,
  Box,
  Button,
  ButtonMode,
  CloseIcon,
  TitleText,
  ButtonSize
} from 'edenred-ui';
import { useTranslation } from 'react-i18next';

import { ITerminationDateDialog } from '@epi-models/pages/Beneficiaries';
import { TerminationDatePicker } from '@epi-pages/Beneficiaries/components/TerminationDate/components/TerminationDatePicker';

import { useEntitledDataDialog } from '../../hooks';

export const EntitledDataDialog = ({
  isOpen,
  handleClose
}: ITerminationDateDialog) => {
  const { gray10, sizeExtraExtraLarge } = useTheme();
  const { t } = useTranslation();
  const { handleSetDate, disableSave, handleSave, isError, dayValue } =
    useEntitledDataDialog(handleClose);

  return (
    <DialogComponent open={isOpen} onClose={handleClose}>
      <Box pt={2} pl={5} borderBottom={1} borderColor={gray10} minWidth={400}>
        <Box position="absolute" right={16}>
          <Button
            id="date-range-dialog-cancel-btn"
            mode={ButtonMode.Link}
            onClick={handleClose}
            type="button"
          >
            <CloseIcon />
          </Button>
        </Box>
        <Box pt={3} maxWidth={310}>
          <TitleText fontWeight={600} fontSize={sizeExtraExtraLarge}>
            {t('containers.beneficiaries.detail.entitled_modal_title')}
          </TitleText>
        </Box>
      </Box>
      <Box
        height={400}
        pt={2.5}
        pl={5}
        pr={5}
        borderBottom={1}
        borderColor={gray10}
        fontSize={16}
      >
        <TerminationDatePicker
          setTerminationDate={handleSetDate}
          isError={isError}
          dayValue={dayValue}
          title={t('containers.beneficiaries.detail.entitled_modal_modal')}
        />
      </Box>
      <Box
        display="flex"
        pt={2}
        justifyContent="flex-end"
        pr={5}
        gap={8}
        pb={2}
      >
        <Button
          id="date-range-dialog-cancel-btn"
          mode={ButtonMode.Link}
          onClick={handleClose}
        >
          {t('download_reports.lunch_deduction.time_period.dialog_cancel')}
        </Button>
        <Button
          id="date-range-dialog-save-btn"
          size={ButtonSize.Large}
          minWidth={135}
          mode={ButtonMode.Primary}
          disabled={disableSave}
          onClick={handleSave}
        >
          {t('download_reports.lunch_deduction.time_period.dialog_save')}
        </Button>
      </Box>
    </DialogComponent>
  );
};
